<modal
  [title]="title"
  [backgroundShading]="backgroundShading"
  [outerWidth]="outerWidth"
  (close)="cancel.emit()"
  (closeMethodRef)="closeMethodRef = $event"
>
  <div class="rv-rows large outer">
    <div>
      <ng-content></ng-content>
    </div>
    <div *ngIf="doNotShowKey">
      <riv-checkbox [(value)]="doNotShowValue">
        Do not show this message again
      </riv-checkbox>
    </div>
  </div>
  <footer class="rv-flex flex-fe">
    <div class="rv-button-set">
      <button
        *ngIf="!hideCancelButton"
        rivButton
        (click)="setCloseMethodWithCancelText(); cancel.emit()"
      >
        {{ cancelText }}
      </button>
      <button
        rivButton
        [variant]="'primary'"
        (click)="
          setDoNotShow();
          setCloseMethodWithConfirmText();
          confirm.emit();
          fireAnalytics()
        "
      >
        {{ confirmText }}
      </button>
    </div>
  </footer>
</modal>
